module.exports = __webpack_public_path__ + "aa16e969906dfe6f1683d16a3c56b808.svg";